import 'suggestions-jquery/dist/js/jquery.suggestions.min';

export function dadataName() {
  const $selector = $('.dadata-name');

  $selector.suggestions({
    token: 'c656e9ed5d73c9705d1b2470522c984c89f17129',
    type: 'NAME',
    params: {
      parts: ['NAME'],
    },
    hint: false,
    beforeRender: () => {
      $selector.addClass('show-suggestions');
    },
    onSelect: () => {
      $selector.removeClass('show-suggestions');
    },
    onSelectNothing: () => {
      $selector.removeClass('show-suggestions');
    },
  });
}
